import { Link, Navigate, useParams } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import { GkCard, GkRowCard } from "@/components/feature/ArticleCards";
import { gkArticles } from "@/mocks/news";
import { gkCategories } from "@/mocks/categories";

const SITE = "https://dqxuaad.cn";

export default function CategoryPage() {
  const { slug } = useParams();
  const cat = gkCategories.find((c) => c.slug === slug);
  if (!cat) return <Navigate to="/" replace />;

  const list = gkArticles.filter((a) => a.category === cat.slug);
  const lead = list[0];
  const others = list.slice(1);
  const otherCats = gkCategories.filter((c) => c.slug !== cat.slug);

  return (
    <>
      <Seo
        title={`${cat.name}瓜田 - ${cat.tagline} | 看吃瓜`}
        description={`${cat.description}看吃瓜${cat.name}栏目，每日更新的今日新瓜与最新爆料，带你把${cat.name}相关的瓜吃明白。`}
        canonicalPath={`/category/${cat.slug}`}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "看吃瓜", item: SITE },
              { "@type": "ListItem", position: 2, name: cat.name, item: `${SITE}/category/${cat.slug}` },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: `${cat.name}瓜田`,
            description: cat.description,
            url: `${SITE}/category/${cat.slug}`,
            hasPart: list.map((a, i) => ({ "@type": "NewsArticle", position: i + 1, headline: a.title, url: `${SITE}/news/${a.id}` })),
          },
        ]}
      />

      <div className="mx-auto max-w-7xl px-4 py-8 md:px-8 md:py-12">
        <nav aria-label="面包屑" className="mb-6 flex items-center gap-2 text-xs text-foreground-500">
          <Link to="/" className="hover:text-primary-600">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-700">{cat.name}瓜田</span>
        </nav>

        {/* Category banner */}
        <div className="relative mb-10 overflow-hidden rounded-3xl">
          <img src={cat.image} alt={`${cat.name}栏目`} className="aspect-[3/1] w-full object-cover md:aspect-[4/1]" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/45 to-transparent"></div>
          <div className="absolute inset-0 flex flex-col justify-center p-6 md:p-10">
            <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-widest text-background-50/80"><i className={cat.icon}></i>栏目瓜田</p>
            <h1 className="font-heading text-3xl font-bold text-background-50 md:text-5xl">{cat.name}瓜田</h1>
            <p className="mt-3 max-w-lg text-sm leading-6 text-background-100/90 md:text-base">{cat.description}</p>
          </div>
        </div>

        {/* Lead + others */}
        {lead && (
          <div className="grid gap-6 lg:grid-cols-5">
            <div className="lg:col-span-2">
              <h2 className="mb-4 font-heading text-xl font-bold text-foreground-950">本栏目精选</h2>
              <GkCard article={lead} imgClass="aspect-[16/10]" />
            </div>
            <div className="lg:col-span-3">
              <h2 className="mb-4 font-heading text-xl font-bold text-foreground-950">更多瓜料</h2>
              <div className="grid gap-4">
                {others.map((a) => (
                  <GkRowCard key={a.id} article={a} />
                ))}
                {others.length === 0 && (
                  <p className="rounded-2xl border border-background-200 bg-background-50 p-8 text-center text-foreground-600">这个栏目正在紧张上瓜中，先去别的瓜田逛逛吧。</p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Other categories */}
        <div className="mt-14">
          <h2 className="mb-6 font-heading text-2xl font-bold text-foreground-950">还想逛别的瓜田？</h2>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {otherCats.map((c) => (
              <Link key={c.slug} to={`/category/${c.slug}`} className="group flex items-center gap-3 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-600"><i className={c.icon}></i></span>
                <div className="min-w-0">
                  <p className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600">{c.name}</p>
                  <p className="truncate text-xs text-foreground-500">{c.tagline}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}